import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import UserDetailsReducer from "./Reducer/UserDetailsReducer";
import ClientDataReducer from "./Reducer/ClientDataReducer";

const persistConfig = {
  key: "persist-key",
  storage,
  blacklist: "digbi",
};

const reducer = combineReducers({
  userDetails: UserDetailsReducer,
  clientData: ClientDataReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
